import { Component } from '@angular/core';
import { Message, PrimeNGConfig, Translation } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { map } from 'rxjs';
import { TranslatableComponent } from './core/i18n/TranslatableComponent';
import { TranslatableStringType } from './core/i18n/types';
import { NotesService } from './core/services/notes.service';
import { AuthActions } from './core/state/auth/auth.actions';
import { CollaborationPackageActions } from './core/state/collaboration-packages/collaboration-packages.actions';
import { i18nFeature } from './core/state/i18n/i18n.reducers';
import { ToastActions } from './core/state/toast/toast.actions';
import { FirmSettingsDialog } from './firm-settings/firm.settings.dialog';
import { openTranslatableDialog } from './shared/misc/openDialog';
import { showTodoDialog } from './shared/misc/showTodoDialog';
import { getTranslationProvider } from './core/i18n/getTranslationProvider';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  providers: [getTranslationProvider('AppComponent')],
})
export class AppComponent extends TranslatableComponent {
  constructor(
    private config: PrimeNGConfig,
    private notesService: NotesService,
    private dialogService: DialogService,
  ) {
    super();

    this.store
      .select(i18nFeature.selectPrimeng)
      .pipe(map((translations) => this.splitArrayishValues(translations)))
      .subscribe((translations: Translation) => {
        this.config.setTranslation(translations);
      });
  }

  private splitArrayishValues(translations: Record<string, TranslatableStringType>) {
    const result: Translation = {};

    Object.entries(translations).forEach(([key, value]) => {
      if (value.includes(',')) {
        result[key] = value.split(',').map((v) => v.trim());
      } else {
        result[key] = value;
      }
    });

    return result;
  }

  public logout() {
    this.store.dispatch(ToastActions.clearsAllToastMessages({}));
    this.store.dispatch(AuthActions.resetAuthStateAndStorage());
    this.store.dispatch(CollaborationPackageActions.clearState({}));
    this.router.navigate(['login']);
  }

  showNewNoteDialog() {
    const deps = {
      notesService: this.notesService,
      dialogService: this.dialogService,
      translationService: this.translationService,
      store: this.store,
    };
    showTodoDialog({ deps, id: -1 });
  }

  showSettingsDialog() {
    const deps = {
      dialogService: this.dialogService,
      translationService: this.translationService,
      store: this.store,
    };
    openTranslatableDialog({ deps, componentType: FirmSettingsDialog, data: {} });
  }

  handleToastButtonClick(message: Message) {
    message.data?.button?.click?.();
    this.store.dispatch(ToastActions.clearsAllToastMessages({}));
  }
}
